<template>
<div id="yagioffer" v-once>  
 
	<section class="hero">
		<div class="hero-deco">
			<img src="/static/yagioffer_img/mv.png" alt="ヤギオファー" class="hero-img pc">
			<img src="/static/yagioffer_img/mv-sp.png" alt="ヤギオファー" class="hero-img sp">
		</div>
		<div class="wrapper">
			<p class="btn_caption">＼就活の1つに／</p>
			<a href="/format/rirekisho_job_new/edit/profile" class="cv-btn">
				<p>ヤギオファーに登録<br><span class="cv-btn_txt">履歴書をつくる</span></p>
			</a>
		</div>
	</section>
	
<!--ヤギオファーとは？-->
	<section class="second">
		<h2 class="second_ti yo_h2">ヤギオファーとは？</h2>
		<div class="wrapper second_contents">
			<img src="/static/yagioffer_img/logo_yagioffer.png" alt="ヤギオファーロゴ" class="second_logo">
			<p class="second_lead">新卒就活生向けサービスです。</p>
			<p class="second_txt">あなたの経歴や興味関心などを見た企業からオファーが届きます。<br>
				企業があなたに送るオファー数には上限が設定されているため、企業はあなたの履歴書を読み、<br class="pc"><span class="txt_bold">1通1通厳選してオファー</span>を送ります。</p>
			<div class="second_charm">
				<h3>ヤギオファーの<span class="txt_color">魅力</span></h3>
				<ul class="second_charm_list">
					<li>ヤギッシュの履歴書を入力するだけで使える！</li>
					<li>あなたに興味を持った会社からオファーが届く！</li>
					<li>様々な業界からオファーが来ることで、就活の可能性が広がる！</li>
				</ul>
				<p class="txt_center">＼さらに／</p>
				<p class="txt_center second_charm_last"><span class="txt_border">オファーを承諾するまで、<br class="pc">名前や住所の個人情報は非公開！<br class="pc"></span>だから安心！</p>
				<img src="/static/yagioffer_img/rirekisyo.png" alt="履歴書" class="rirekisyo_img">
			</div>
		</div>

		<a href="https://rirekisho.yagish.jp/format/rirekisho_job_new/edit/profile" class="cv-btn">
			<p>ヤギオファーに登録<br><span class="cv-btn_txt">履歴書をつくる</span></p>
		</a>

	</section>
	
	<!--使い方-->
	<section class="third">
		<div class="wrapper">
			<h2 class="yo_h2"><img src="/static/yagioffer_img/2step.png" alt="簡単！2step！"></h2>
			<div class="third_step flex">
				<img src="/static/yagioffer_img/step01.png" alt="履歴書を入力" class="third_step_item">
				<img src="/static/yagioffer_img/step02.png" alt="スカウトを受けるかはあなた次第！" class="third_step_item">
			</div>
			<p class="txt_center third_lead">＼こんなメッセージが届くよ／</p>
			<p class="txt_center">マイページで確認！</p>
			<img src="/static/yagioffer_img/offer_exam.png" alt="メッセージ画面" class="offer_exam_img">
		</div>
	</section>
	
	<section class="fqa wrapper">
		<h3 class="fqa-ti">よくあるご質問</h3>
		<ul class="fqa-container">
			<li class="fqa-list">
				<h4 class="question">オファーを受けるとどうなるの？</h4>
				<p class="answer">オファーを受けたあと、オファーを承認するとその企業と直接コミュニケーションをとることができ、説明会に案内してもらえたり、選考へと進んだりすることができます（企業により異なります）。オファーを送った企業に興味がなければ、オファーを辞退することもできます。辞退した場合は、企業の方と連絡をとることができません。</p>
			</li>
			<li class="fqa-list">
				<h4 class="question">お金はかからないの？</h4>
				<p class="answer">無料です。登録もその後のご利用も、全ての機能を無料で利用できますのでお気軽にご登録ください。</p>
			</li>
			<li class="fqa-list">
				<h4 class="question">他の学生に自分のプロフィールは見られない？</h4>
				<p class="answer">ヤギオファーでは、作成した履歴書情報は企業の方のみが参照できます。他の利用学生から履歴書を見られることはありませんので、安心して思いきって自分をアピールしてみましょう。</p>
			</li>
		</ul>
	</section>

	<a href="/format/rirekisho_job_new/edit/profile" class="cv-btn">
		<p>ヤギオファーに登録<br><span class="cv-btn_txt">履歴書をつくる</span></p>
	</a>
	
	<div style="text-align: center; padding: 20px;">
		<a href="/yagiofferterms" target="_blank">利用規約は<span style="color: #E3165C;">こちら</span></a>
	</div>

</div>
</template>
<style lang="css" src="@/assets/css/yagioffer_stylesheet.css"></style>
<style lang="css" src="@/assets/css/yagioffer_reset.css"></style>

<style lang="scss" scoped>
.yo_h2:before{display: none;}
</style>

<script>
export default {
  data: function () {
    return {
      question1:false,
      question2:false,
      question3:false,
      question4:false,
      question5:false,
      question6:false,
      question7:false,
      question8:false
    }
  },
  computed: {},
  methods: {
    viewAnswer: function(name) {
      console.error(name)
      this.question1 = true
    }
  },
  watch: {},
  mounted: function () {}
}
</script>
